"use client";

import DefaultPageComponent from "./components/ui/DefaultPageComponent";
import React from "react";

const NotFound = () => {
  return (
    <>
      <DefaultPageComponent
        svg={NotFoundSvg}
        text="The page you're looking for can't be found. It may have been moved, deleted, or the URL might be incorrect. Please check the address again or return to our homepage to find what you need."
        image="/images/not-found-optimize.gif"
      />
    </>
  );
};
export default NotFound;

export const NotFoundSvg = () => {
  return (
    <div className="size-[10rem] mx-auto mb-6">
      <svg
        width="100%"
        height="auto"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 7V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H7M17 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V7M21 17V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H17M7 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V17"
          stroke="rgba(var(--primary-color-rgb), 0.5)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          stroke="var(--primary-color)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0001 16L14.1001 14.1"
          stroke="var(--primary-color)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};
